// Vendors
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';
// Services
import { declineOrderService } from '../services/session-expire-timeout.services';

const declineOrderResolver = async (): Promise<[boolean]> => {
  const [, { status }] = await declineOrderService();
  return [requestHasSuccessStatus(status)];
};

export { declineOrderResolver };
